export enum ApiConstants {

    SUCCESS = <any>'SUCCESS',
    SERVER_ERROR = <any>'SERVER_ERROR',
    INVALID_API_REQUEST = <any>'INVALID_API_REQUEST',
    VALIDATION_ERROR = <any>'VALIDATION_ERROR',
    INV_PERM = <any>'INV_PERM',
    UNAUTH_REQUEST = <any>'UNAUTH_REQUEST',
    INVALID_CATEGORY = <any>'INVALID_CATEGORY',
    INVALID_PRODUCT = <any>'INVALID_PRODUCT',
    DUPLICATE_USERNAME = <any>'DUPLICATE_USERNAME',
    DUPLICATE_EMAIL = <any>'DUPLICATE_EMAIL',
    INVALID_LOGIN = <any>'INVALID_LOGIN',
    INVALID_PASSWORD = <any>'INVALID_PASSWORD',
    INACTIVE_USER = <any>'INACTIVE_USER',
    INV_SUPP_CODE = <any>'INV_SUPP_CODE',
    INVALID_PROMOTION = <any>'INVALID_PROMOTION'
}
